module.exports = __webpack_public_path__ + "media/entities/1126-f77fa6f4.png";